<div class="forgot-password-container">
  <mat-card class="forgot-password-card">
    <mat-card-header>
      <img src="assets/images/logo_full_900.png" alt="Logo" />
    </mat-card-header>
    <mat-card-content style="width:100%;">
      
      @if(loading) {
        <div class="center">
          <app-loader></app-loader>
        </div>
      } @else if(error) {
        <div class="center">
          <p class="warning-color" style="margin: 20px 0;">{{ error }}</p>
        </div>
      } @else if(showForm) {
        <div class="form">
          <div class="form-row">
            <mat-form-field appearance="outline" class="full-width">
              <mat-label>New Password</mat-label>
              <input matInput type="password" required [(ngModel)]="password" name="password" [ngModelOptions]="{standalone: true}" autocomplete="new-password">
              <mat-icon matSuffix>password</mat-icon>
            </mat-form-field>      
          </div>
          <div class="form-row">
            <mat-form-field appearance="outline" class="full-width">
              <mat-label>Confirm New Password</mat-label>
              <input matInput type="password" required [(ngModel)]="confirmPassword" name="confirmPassword" [ngModelOptions]="{standalone: true}" autocomplete="new-password">
              <mat-icon matSuffix>password</mat-icon>
            </mat-form-field>      
          </div>
          <div class="center">
              <button type="button" mat-flat-button class="metallic-text-btn-blue" (click)="submitNewPassword()"
                [disabled]="!email || !password || password !== confirmPassword">
                Reset
                <mat-icon>send</mat-icon>
              </button>
          </div>
        </div> 
      }

    </mat-card-content>
  </mat-card>
</div>